import axios from "axios";
import { domain } from "../Links/Links";
import { getCookie } from "../../App";

export async function depositConfirmationRequest(
  event,
  user,
  amount,
  notifID,
  walletHistoryID,
) {
  const data = { 
    user: user,
    amount: amount,
    notif_id: notifID,
    wallet_history_id: walletHistoryID,
  };
  const response = await axios.post(domain + "/deposit_confirmation/", data, {
    withCredentials: true,
    headers: {
      "X-CSRFToken": getCookie("csrf_token"),
    },
  });

  if (response.data.ok == 'ok') {
    event.target.innerHTML = 'Completed';
  }
}
